<template>
  <pt-classify-table class="pt-classify-table__page"></pt-classify-table>
</template>

<script>
import PtClassifyTable from 'cps/information-manage/pt-news-manage/pt-news-classify/pt-classify-table/withData'
export default {
  name: 'pt-classify-table__view',
  components: {
    'pt-classify-table': PtClassifyTable
  }
}
</script>
